export default "__VITE_ASSET__DBirAO_$__"